import dayjs from 'dayjs'
import CryptoJS from 'crypto-js'

export const cryptoPassword = (password) => {
  const key = CryptoJS.enc.Utf8.parse('d2k9b5w7m8g4er26d2k9b5w7m8g4er26')
  const iv = CryptoJS.enc.Utf8.parse('0123456789abcdef')
  const encrypted = CryptoJS.AES.encrypt(password, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  return encrypted.toString()
}

export const decryptPassword = (encrypted) => {
  const key = CryptoJS.enc.Utf8.parse('d2k9b5w7m8g4er26d2k9b5w7m8g4er26')
  const iv = CryptoJS.enc.Utf8.parse('0123456789abcdef')
  const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}

export const formatTime = (
  /** @type {string | number | Date | dayjs.Dayjs | null | undefined} */ value:
    | string
    | number
    | Date
    | dayjs.Dayjs
    | null
    | undefined,
  /** @type {string | undefined} */ format: string | undefined
) => {
  if (!value) return '-'
  if (typeof format !== 'string') format = 'YYYY-MM-DD HH:mm:ss'
  return dayjs(value).format(format)
}
export const formatDay = (
  /** @type {string | number | Date | dayjs.Dayjs | null | undefined} */ value:
    | string
    | number
    | Date
    | dayjs.Dayjs
    | null
    | undefined,
  /** @type {string | undefined} */ format: string | undefined
) => {
  if (!value) return '-'
  if (typeof format !== 'string') format = 'YYYY-MM-DD'
  return dayjs(value).format(format)
}

export const formatTxt = (/** @type {number} */ value: number) => {
  if (value === 0) return value
  if (!value) return '-'
  return value
}

export const debounce = (
  /** @type {{ apply: (arg0: any, arg1: IArguments) => void; }} */ fn: {
    apply: (arg0: any, arg1: IArguments) => void
  },
  /** @type {number | undefined} */ delay: number | undefined
) => {
  let timer: any = null
  return function (this: any) {
    let context = this
    let args = arguments
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(context, args)
    }, delay)
  }
}

export const download = (
  /** @type {BlobPart} */ res: BlobPart,
  /** @type {any} */ type: any,
  /** @type {string} */ filename: string
) => {
  // 创建blob对象，解析流数据
  const blob = new Blob([res], {
    // 设置返回的文件类型
    // type: 'application/pdf;charset=UTF-8' 表示下载文档为pdf，如果是word则设置为msword，excel为excel
    type: type,
  }) // 这里就是创建一个a标签，等下用来模拟点击事件
  const a = document.createElement('a') // 兼容webkit浏览器，处理webkit浏览器中href自动添加blob前缀，默认在浏览器打开而不是下载
  const URL = window.URL || window.webkitURL // 根据解析后的blob对象创建URL 对象
  const href = URL.createObjectURL(blob) // 下载链接
  a.href = href // 下载文件名,如果后端没有返回，可以自己写a.download = '文件.pdf'
  a.download = filename
  document.body.appendChild(a) // 点击a标签，进行下载
  a.click() // 收尾工作，在内存中移除URL 对象
  document.body.removeChild(a)
  window.URL.revokeObjectURL(href)
}

export const tree2Array = (tree: any, childrenName = 'children') => {
  let arr: any = []
  tree.forEach((item: any) => {
    arr.push(item)
    if (item[childrenName]) {
      arr = arr.concat(tree2Array(item[childrenName], childrenName))
    }
  })
  return arr
}



